// filepath: apps/web/src/features/admin/effects/EmailChannelsRoute.tsx
//
// FR-UI-ADM-8 AC-3 -- route shell for the email channel admin editor.
// URL: /admin/effects/email-channels

import React from "react";
import { StagingOnlyError } from "@/features/admin/StagingOnlyError";
import { EmailChannelsPage } from "./EmailChannelsPage";

interface EmailChannelsRouteProps {
  environmentKind: string;
}

export function EmailChannelsRoute({
  environmentKind,
}: EmailChannelsRouteProps): React.ReactElement {
  if (environmentKind !== "staging") {
    return <StagingOnlyError environmentKind={environmentKind} />;
  }
  return <EmailChannelsPage environmentKind={environmentKind} />;
}
